module.exports = __webpack_public_path__ + "img/music-filter.e08be31d.svg";